export default __webpack_public_path__ + "static/media/BASSETS-1.8db48b79.png";